export const stringToCapitalized = (s: string): string => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const stringToCapitalizedWord = (str: string): string => {
  const splitStr = str.toLowerCase().split(' ');
  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] = stringToCapitalized(splitStr[i]);
  }
  return splitStr.join(' ');
};

export const stringToTruncated = (text: string, length: number): string => {
  if (!text) {
    return '';
  }

  if (text.length <= length) {
    return text;
  }

  return `${text.substr(0, length)}${'\u2026'}`;
};

export const sharedStart = (array: string[]): string => {
  const A = array.concat().sort(),
    a1 = A[0],
    a2 = A[A.length - 1],
    L = a1.length;
  let i = 0;
  while (i < L && a1.charAt(i) === a2.charAt(i)) {
    i++;
  }
  return a1.substring(0, i);
};

export const queryNamesForSearchText = (text: string) => {
  // Create an array of strings by separating words to pass on as matching names
  const keywordRegex = /[\p{L}0-9_]+/giu;
  const keywordString = text.toLowerCase();
  const regexResult = keywordString.match(keywordRegex);
  return regexResult ? regexResult.map((r) => r) : [keywordString];
};

export const createQueryNamesForWord = (word: string, minLength?: number) => {
  const subnames: string[] = [];
  for (let i = minLength ? minLength - 1 : 0; i < word.length; i++) {
    const subname = word.substring(0, i + 1).trim();
    if (subname.length > 0) {
      subnames.push(subname);
    }
  }
  return subnames;
};

export const createSearchableQueryNames = (text: string) => {
  const queryNames = queryNamesForSearchText(text).flatMap((word) => createQueryNamesForWord(word));
  return queryNames;
};

export const createQueryName = (text: string) => {
  return text.replace(/\W+/g, '-').toLowerCase();
};

export const getNumberValueFromString = (stringValue: string | undefined): number | undefined => {
  if (!stringValue || stringValue.length === 0) {
    return undefined;
  }
  return Number.parseInt(stringValue, 10);
};

const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};

export const replaceAll = (str: string, match: string, replacement: string) => {
  return str.replace(new RegExp(escapeRegExp(match), 'g'), () => replacement);
};
